





































import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import debounce from 'lodash.debounce';
import { TransceiversApi, Transceiver } from '@/api';
import { Validation } from 'vuelidate';
import { VueSelect } from 'vue-select';

@Component({
	components: { VueSelect },
})
export default class TransceiverSuggest extends Vue {
	// computed
	get validationState() {
		if (this.validator) {
			return this.validator.$dirty && this.validator.$invalid;
		}
		return null;
	}

	@PropSync('transceiver') public localTransceiver!: Transceiver;

	@Prop(Object)
	public readonly validator?: Validation;

	@Prop(Boolean)
	public readonly disabled?: boolean;

	@Prop(Boolean)
	public readonly state?: boolean;

	@Prop(Array)
	public type: string[] | [] | undefined;

	@Prop({ type: String, default: '--No Transceiver Selected--' })
	public readonly placeholder!: string;

	public options: Transceiver[] = [];
	private api: TransceiversApi;

	constructor() {
		super();
		this.api = new TransceiversApi();
		this.debouncedOptions = debounce(this.fetchOptions, 100);
	}

	public onSelect(transceiver: Transceiver) {
		if (this.validator) {
			this.validator.$touch();
		}

		this.localTransceiver = transceiver;
		this.$emit('input', transceiver);
	}

	public onSearch(search: string) {
		this.debouncedOptions.cancel();
		this.debouncedOptions(search);
	}

	public async fetchOptions(search: string) {
		// get orgs
		const options = {
			params: {
				'filter[serialNumber]': search,
				'filter[type]': this.type,
				include: 'site',
			},
		};
		const response = await this.api.getTransceivers(options);
		this.options = response.data.data || [];
	}

	private readonly debouncedOptions: any = () => {
		return [];
	};
}
